export default "__VITE_ASSET__DiUVDsn9__"